import { Box } from '@mui/material';
import SvgIconStyle from '@components/SvgIconStyle';
import { FC } from 'react';
import { Color as ColorType } from '../../types';
import { useStyles } from './styles';

type Props = {
  color: ColorType;
  activeColor: ColorType;
  setActiveColor: React.Dispatch<React.SetStateAction<ColorType>>;
};

const Color: FC<Props> = ({ color, activeColor, setActiveColor }) => {
  const styles = useStyles({ color });

  return (
    <Box
      onClick={() => setActiveColor(color)}
      sx={activeColor === color ? styles.activeColorBox : styles.colorBox}
    >
      {activeColor === color && (
        <SvgIconStyle src="/icons/approve_tick/24/outline.svg" sx={styles.icon} />
      )}
    </Box>
  );
};

export default Color;
